<template>
  <div class="main">
    <!--    <a-form-->
    <!--      id="formLogin"-->
    <!--      class="user-layout-login"-->
    <!--      ref="formLogin"-->
    <!--      :form="form"-->
    <!--      @submit="handleSubmit"-->
    <!--    >-->
    <!--      <a-form-item>-->
    <!--        <a-input-->
    <!--          size="large"-->
    <!--          type="text"-->
    <!--          placeholder="请输入账号"-->
    <!--          v-decorator="[-->
    <!--            'username',-->
    <!--            {rules: [{ required: true, message: '请输入账号' }], validateTrigger: 'change'}-->
    <!--          ]"-->
    <!--        >-->
    <!--          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>-->
    <!--        </a-input>-->
    <!--      </a-form-item>-->

    <!--      <a-form-item>-->
    <!--        <a-input-->
    <!--          size="large"-->
    <!--          type="password"-->
    <!--          autocomplete="false"-->
    <!--          placeholder="请输入密码"-->
    <!--          v-decorator="[-->
    <!--            'password',-->
    <!--            {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}-->
    <!--          ]"-->
    <!--        >-->
    <!--          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>-->
    <!--        </a-input>-->
    <!--      </a-form-item>-->

    <!--      <a-form-item style="margin-top:40px">-->
    <!--        <a-button-->
    <!--          size="large"-->
    <!--          type="primary"-->
    <!--          htmlType="submit"-->
    <!--          class="login-button"-->
    <!--          :loading="state.loginBtn"-->
    <!--          :disabled="state.loginBtn"-->
    <!--        >确定</a-button>-->
    <!--      </a-form-item>-->
    <!--    </a-form>-->
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

export default {
  data () {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false
      }
    }
  },
  created () {
  },
  mounted () {
    const query = location.search.split('=')
    if (query[0].indexOf('token') != -1 ) {
      this.handleSubmit(query[1])
      console.log(query,111)
    } else {
      // 打开测试地址
      window.open('https://desktop.jgyljt.com/', '_self')
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // handler
    handleSubmit (e) {
      // e.preventDefault()
      const {
        // form: { validateFields },
        // state,
        Login
      } = this
      Vue.ls.set(ACCESS_TOKEN, e, 7 * 24 * 60 * 60 * 1000)
      // const validateFieldsKey = ['username', 'password']
      // validateFields(validateFieldsKey, { force: true }, (err, values) => {
      // if (!err) {
      //   state.loginBtn = true
      Login({})
        .then((res) => this.loginSuccess(res))
        .catch(err => this.requestFailed(err))
        .finally(() => {
          // state.loginBtn = false
        })
        // } else {
        //   setTimeout(() => {
        //     state.loginBtn = false
        //   }, 600)
        // }
      // }
      // )
    },
    loginSuccess (res) {
      this.$router.push({ path: '/dishes' })
      // 延迟 1 秒显示欢迎信息
      // console.log(res)
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed (err) {
      // console.log(err)
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
